// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c68dc1fb","265":"6a464ce0","337":"59c5ce04","777":"0f160cb4"}[chunkId] + ".chunk.js";
};